module.exports = __webpack_public_path__ + "static/media/visa.517bc552.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/visa.svg
// module id = 797
// module chunks = 0